import { render, staticRenderFns } from "./LdmtLomStatusList.vue?vue&type=template&id=5728dabd"
import script from "./LdmtLomStatusList.vue?vue&type=script&lang=js"
export * from "./LdmtLomStatusList.vue?vue&type=script&lang=js"
import style0 from "./LdmtLomStatusList.vue?vue&type=style&index=0&id=5728dabd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports